import React, { useState } from "react";
import {
  Avatar,
  Box,
  useMediaQuery,
  IconButton,
  Drawer,
  Menu,
  MenuItem,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../Redux/AuthSlice";
import MenuIcon from "@mui/icons-material/Menu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import logo from "../Utils/Logo.svg";
import ButtonComp from "./MUI/Button";
import {
  colorNavbar,
  colorOrange,
  outlineColor,
  textColor,
} from "../Styles/Colors";

const Navbar = () => {
  const matches = useMediaQuery("(min-width:800px)");
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleUserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    navigate("/Login");
    handleUserMenuClose();
  };

  const handleLogin = () => {
    navigate("/Login");
    handleUserMenuClose();
  };

  const menuItems = (
    <Box
      display="flex"
      justifyContent={!matches ? "space-between" : "flex-end"}
      width={"100%"}
    >
      <Box
        display="flex"
        flexDirection={matches ? "row" : "column"}
        gap="8px"
        justifyContent={matches ? "flex-end" : "center"}
        alignItems={matches ? "center" : "flex-start"}
      >
        <ButtonComp
          icon={<NotificationsNoneIcon sx={{ fontSize: "15px" }} />}
          style={{
            width: "131px",
            backgroundColor: "transparent",
            borderRadius: "8px",
          }}
          label="Notifications"
        >
          Notifications
        </ButtonComp>
        <ButtonComp
          icon={<HelpOutlineIcon sx={{ fontSize: "15px" }} />}
          style={{
            width: "131px",
            backgroundColor: colorOrange,
            borderRadius: "8px",
            color: textColor,
          }}
          label="Help Desk"
        >
          Help Desk
        </ButtonComp>
      </Box>

      {isAuthenticated ? (
        <>
          <ButtonComp
            icon={
              <Avatar
                sx={{ width: "24px", height: "24px" }}
                alt={user?.name || "User"}
                src="/static/images/avatar/1.jpg"
              />
            }
            style={{
              width: "128px",
              backgroundColor: "transparent",
              border: `1px solid ${outlineColor}`,
              borderRadius: "30px",
              padding: "0px 4px",
              marginLeft: matches ? "12px" : "0px",
            }}
            onClick={handleUserMenuOpen}
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleUserMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleLogout}>
              <LogoutIcon sx={{ mr: 1, fontSize: 16 }} />
              Logout
            </MenuItem>
          </Menu>
        </>
      ) : (
        <ButtonComp
          icon={<LoginIcon sx={{ fontSize: "15px" }} />}
          style={{
            width: "100px",
            backgroundColor: colorOrange,
            borderRadius: "8px",
            color: textColor,
            marginLeft: matches ? "12px" : "0px",
          }}
          onClick={handleLogin}
        >
          Login
        </ButtonComp>
      )}
    </Box>
  );

  return (
    <Box maxWidth="1440px" height="62px" zIndex="2000" top="0">
      <Box
        display="flex"
        position="fixed"
        alignItems="center"
        zIndex="200"
        top="0"
        bgcolor={colorNavbar}
        justifyContent="space-between"
        height="62px"
        maxWidth="1440px"
        width="100%"
        px={matches ? 2 : 1}
      >
        <img
          width="170px"
          height="33px"
          style={{ padding: 0, margin: 0 }}
          src={logo}
          alt="Logo"
        />

        {matches ? (
          menuItems
        ) : (
          <>
            <IconButton onClick={() => setOpenMenu(true)}>
              <MenuIcon sx={{ color: "white" }} />
            </IconButton>
            <Drawer
              anchor="top"
              open={openMenu}
              onClose={() => setOpenMenu(false)}
            >
              <Box
                bgcolor={colorNavbar}
                p={2}
                display="flex"
                flexDirection="column"
                gap="12px"
              >
                {menuItems}
              </Box>
            </Drawer>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Navbar;
